var _path, _path2, _path3, _path4, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNotFound(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 81,
    height: 81,
    viewBox: "0 0 81 81",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M70.9621 9.49717C58.465 -2.99971 38.1311 -2.99971 25.6342 9.49717C13.5079 21.6237 13.1484 41.1292 24.5559 53.6933L20.2349 58.0142L17.9039 55.6832C17.6108 55.3901 17.2133 55.2254 16.7988 55.2254C16.3843 55.2254 15.9868 55.3901 15.6938 55.6832L2.21591 69.1612C1.00287 70.3741 0.334778 71.9868 0.334778 73.7023C0.334778 75.4178 1.00287 77.0305 2.21576 78.2435C3.4288 79.4564 5.0416 80.1245 6.75692 80.1245C8.4724 80.1245 10.085 79.4564 11.2981 78.2435L24.7761 64.7657C25.0691 64.4726 25.2338 64.0751 25.2338 63.6606C25.2338 63.2461 25.0691 62.8486 24.7761 62.5556L22.445 60.2245L26.766 55.9035C32.856 61.433 40.5772 64.1977 48.2981 64.1977C56.5059 64.1977 64.7136 61.0736 70.9621 54.825C83.459 42.328 83.459 21.994 70.9621 9.49717ZM9.08798 76.0332C8.46536 76.6559 7.63755 76.9989 6.75692 76.9989C5.87644 76.9989 5.04847 76.656 4.42586 76.0332C3.80324 75.4106 3.46036 74.5828 3.46036 73.7023C3.46036 72.8219 3.80324 71.9939 4.42601 71.3713L16.7988 58.9983L21.4609 63.6604L9.08798 76.0332ZM68.752 52.6148C57.4738 63.8931 39.1227 63.8931 27.8445 52.6149C16.5661 41.3366 16.5661 22.9855 27.8443 11.7073C33.4835 6.06809 40.891 3.2485 48.2981 3.2485C55.7055 3.2485 63.1128 6.06809 68.7518 11.7073C80.0302 22.9855 80.0302 41.3366 68.752 52.6148Z",
    fill: "url(#paint0_linear_135_1297)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M73.4313 31.8556C73.2982 31.2022 72.7568 30.6952 72.0942 30.6107C71.4436 30.5277 70.7864 30.8793 70.4992 31.4696C70.2168 32.0496 70.3182 32.7578 70.7606 33.2298C71.2073 33.7061 71.9216 33.8529 72.5205 33.5942C73.1866 33.3067 73.5757 32.5676 73.4313 31.8556Z",
    fill: "url(#paint1_linear_135_1297)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M71.2721 37.8114C70.4487 37.5517 69.5712 38.0085 69.3116 38.8316C68.2414 42.2234 66.4173 45.2247 63.8897 47.7524C59.7251 51.9169 54.188 54.2106 48.2981 54.2106C42.4084 54.2106 36.8712 51.9171 32.7065 47.7524C24.1094 39.1551 24.1094 25.1666 32.7065 16.5693C36.8712 12.4046 42.4084 10.1111 48.2981 10.1111C54.188 10.1111 59.7251 12.4046 63.8897 16.5693C66.3889 19.0686 68.2669 22.1632 69.3205 25.5185C69.5792 26.3421 70.4567 26.7998 71.2798 26.5412C72.1032 26.2827 72.5611 25.4054 72.3025 24.5819C71.0985 20.7481 68.9537 17.213 66.0998 14.3591C61.3448 9.60397 55.0227 6.98535 48.2981 6.98535C41.5736 6.98535 35.2515 9.60397 30.4964 14.3591C20.6805 24.175 20.6805 40.1466 30.4964 49.9625C35.2515 54.7174 41.5734 57.3362 48.2981 57.3362C55.0228 57.3362 61.3448 54.7176 66.0998 49.9625C68.9455 47.1169 71.0868 43.5932 72.2923 39.7721C72.5519 38.9488 72.0953 38.071 71.2721 37.8114Z",
    fill: "url(#paint2_linear_135_1297)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M38.7073 41.752C40.7277 43.7724 44.0152 43.7724 46.0355 41.752L48.2983 39.4892L50.5609 41.752C51.5711 42.7622 52.8981 43.2673 54.225 43.2673C55.552 43.2673 56.879 42.7622 57.8892 41.752C59.9095 39.7316 59.9095 36.4441 57.8892 34.4238L55.6264 32.161L57.8892 29.8982C59.9095 27.8778 59.9095 24.5905 57.8892 22.57C55.8688 20.5496 52.5813 20.5496 50.5609 22.57L48.2981 24.8329L46.0354 22.57C44.0148 20.5496 40.7277 20.5496 38.7071 22.57C36.6868 24.5904 36.6867 27.8778 38.7073 29.8982L40.9701 32.161L38.7071 34.4238C36.6869 36.444 36.6867 39.7315 38.7073 41.752ZM40.9174 36.6339L44.2852 33.266C44.5782 32.973 44.7429 32.5754 44.7429 32.161C44.7429 31.7465 44.5782 31.349 44.2852 31.0559L40.9174 27.6881C40.1157 26.8864 40.1157 25.5819 40.9174 24.7802C41.7189 23.9787 43.0237 23.9785 43.8253 24.7802L47.1931 28.148C47.4863 28.4412 47.8837 28.6058 48.2981 28.6058C48.7126 28.6058 49.1102 28.4411 49.4032 28.148L52.771 24.7802C53.5727 23.9785 54.8773 23.9785 55.6789 24.7802C56.4806 25.5819 56.4806 26.8864 55.6789 27.6881L52.3111 31.0559C52.0181 31.349 51.8533 31.7465 51.8533 32.161C51.8533 32.5754 52.0181 32.973 52.3111 33.266L55.6789 36.6339C56.4806 37.4356 56.4806 38.74 55.6789 39.5417C54.8775 40.3435 53.5729 40.3436 52.771 39.5417L49.4032 36.1739C49.1102 35.8807 48.7126 35.7162 48.2981 35.7162C47.8837 35.7162 47.4861 35.8809 47.1931 36.1739L43.8253 39.5417C43.0237 40.3435 41.7191 40.3435 40.9174 39.5417C40.1157 38.74 40.1155 37.4356 40.9174 36.6339Z",
    fill: "url(#paint3_linear_135_1297)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_135_1297",
    x1: 93.0293,
    y1: -19.0468,
    x2: -24.1105,
    y2: 5.04864,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF6A25"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#CD42FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8FB9FC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_135_1297",
    x1: 73.9564,
    y1: 29.8505,
    x2: 69.3875,
    y2: 30.7898,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF6A25"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#CD42FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8FB9FC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_135_1297",
    x1: 80.1883,
    y1: -5.08077,
    x2: 7.96037,
    y2: 9.44865,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF6A25"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#CD42FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8FB9FC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_135_1297",
    x1: 62.9292,
    y1: 15.7316,
    x2: 30.4044,
    y2: 22.4219,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF6A25"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#CD42FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8FB9FC"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotFound);
export default __webpack_public_path__ + "static/media/not-found.79a787cc783be03fe86087eaebb5b408.svg";
export { ForwardRef as ReactComponent };